import React, { useState } from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePrivate from '@afosto/auth-react/usePrivate';
import useSessionManager from '@afosto/auth-react/useSessionManager';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Icon from '@afosto/app-components-react/Icon';
import copyToClipboard from '@afosto/utils/copyToClipboard';
import translations from './translations';

const DeveloperSettings = () => {
  usePrivate();

  const intl = useIntl();
  const sessionManager = useSessionManager();
  const [openTooltipID, setOpenTooltipID] = useState(null);
  const { tenant: tokenTenant } = sessionManager?.tokenMetadata ?? {};

  return (
    <Card>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      <Divider />
      <ClickAwayListener onClickAway={() => setOpenTooltipID(null)}>
        <List dense disablePadding>
          <ListItem divider>
            <Box display="flex" width="100%" py={1}>
              <Box flex={1}>
                <Typography variant="body2">
                  {intl.formatMessage(translations.properties.tenantID)}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {tokenTenant ?? '-'}
                </Typography>
              </Box>
              {tokenTenant && (
                <Box ml={2}>
                  <div>
                    <Tooltip
                      onClose={() => setOpenTooltipID(null)}
                      open={openTooltipID === 'tenantID'}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      title={intl.formatMessage(translations.tooltip.copiedTenantID)}
                    >
                      <IconButton
                        edge="end"
                        aria-label={intl.formatMessage(translations.tooltip.copiedTenantID)}
                        onClick={() => {
                          copyToClipboard(tokenTenant);
                          setOpenTooltipID('tenantID');
                        }}
                      >
                        <Icon icon={['fal', 'copy']} />
                      </IconButton>
                    </Tooltip>
                  </div>
                </Box>
              )}
            </Box>
          </ListItem>
          <ListItem>
            <Box display="flex" width="100%" py={1}>
              <Box flex={1}>
                <Typography variant="body2">
                  {intl.formatMessage(translations.properties.JWT)}
                </Typography>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{ wordBreak: 'break-all' }}
                >
                  {sessionManager?.token ? `${sessionManager?.token?.substring(0, 120)}...` : '-'}
                </Typography>
              </Box>
              {sessionManager?.token && (
                <Box>
                  <div>
                    <Tooltip
                      onClose={() => setOpenTooltipID(null)}
                      open={openTooltipID === 'JWT'}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      title={intl.formatMessage(translations.tooltip.copiedJWT)}
                    >
                      <IconButton
                        edge="end"
                        aria-label={intl.formatMessage(translations.tooltip.copiedJWT)}
                        onClick={() => {
                          const matches = sessionManager.token.match(/.*(?=\.)/);
                          const [firstMatch] = matches ?? [];

                          copyToClipboard(firstMatch);
                          setOpenTooltipID('JWT');
                        }}
                      >
                        <Icon icon={['fal', 'copy']} />
                      </IconButton>
                    </Tooltip>
                  </div>
                </Box>
              )}
            </Box>
          </ListItem>
        </List>
      </ClickAwayListener>
    </Card>
  );
};

export default DeveloperSettings;
